export const convertToValidHTMLId = (id: string) => {
  let validId = id.replaceAll(" ", "-")

  // Remove all non-authorized symbol, for example the copyright symbol
  validId = validId.replaceAll(/[^(a-z)(A-Z)(0-9)._-]/g, "")

  return validId
}
